import type { CustomerRecord } from '../CustomerLogin';
import { PRODUCT_PREMIUM, PRODUCT_STANDARD } from '../../constants';

/** PB-Felder ohne PII — nur bereits im Login gemappte Keys (tier). */
export function resolveArbeitskontextLabel(customer: Pick<CustomerRecord, 'tier'>): string | null {
  if (customer.tier === 'premium') return PRODUCT_PREMIUM;
  if (customer.tier === 'standard') return PRODUCT_STANDARD;
  return null;
}

export function formatDocumentCount(count: number | null | undefined): string {
  if (count == null || count < 0) return '—';
  if (count === 0) return 'keine Dokumente';
  if (count === 1) return '1 Dokument';
  return `${count} Dokumente`;
}
